import type { RoleConfig, RouteConfig, UserRole, Permission } from '../types/auth';

// Configuración de roles y sus permisos por defecto
export const ROLE_CONFIG: RoleConfig = {
  superadmin: {
    name: 'Super Administrador',
    description: 'Acceso completo a todas las funcionalidades del sistema',
    defaultPermissions: [
      'dashboard.view',
      'leads.view', 'leads.create', 'leads.edit', 'leads.delete',
      'deals.view', 'deals.create', 'deals.edit', 'deals.delete',
      'contacts.view', 'contacts.create', 'contacts.edit', 'contacts.delete',
      'users.view', 'users.create', 'users.edit', 'users.delete',
      'funcionarios.view', 'funcionarios.create', 'funcionarios.edit', 'funcionarios.delete',
      'eventos.view', 'eventos.create', 'eventos.edit', 'eventos.delete',
      'accesos.view', 'accesos.create', 'accesos.edit', 'accesos.delete',
      'reports.view', 'reports.export',
      'configuracion.view', 'configuracion.edit',
      'callcenter.view', 'callcenter.create', 'callcenter.edit',
      'puertas.view', 'puertas.control'
    ],
    allowedRoutes: ['*'], // Acceso a todas las rutas
    restrictions: {
      canEditOwnData: true,
      canViewAllData: true,
      canDeleteData: true,
    }
  },
  admin: {
    name: 'Administrador',
    description: 'Administrador con acceso a la mayoría de funcionalidades',
    defaultPermissions: [
      'dashboard.view',
      'leads.view', 'leads.create', 'leads.edit', 'leads.delete',
      // 'deals.view', 'deals.create', 'deals.edit', 'deals.delete',
      // 'contacts.view', 'contacts.create', 'contacts.edit', 'contacts.delete',
      // 'users.view', 'users.create', 'users.edit',
      // 'funcionarios.view', 'funcionarios.create', 'funcionarios.edit', 'funcionarios.delete',
      // 'eventos.view', 'eventos.create', 'eventos.edit', 'eventos.delete',
      // 'accesos.view', 'accesos.create', 'accesos.edit', 'accesos.delete',
      // 'reports.view', 'reports.export',
      'configuracion.view',
      'imports.view',

      // 'callcenter.view', 'callcenter.create', 'callcenter.edit',
      // 'puertas.view', 'puertas.control'
    ],
    allowedRoutes: [
      'dashboard', 'dashboarddeals','leads', 'deals', 'contacts',  'settings', 'imports'
    ],
    restrictions: {
      canEditOwnData: true,
      canViewAllData: true,
      canDeleteData: true,
    }
  },
  manager: {
    name: 'Gerente',
    description: 'Gerente con acceso a gestión de equipos y reportes',
    defaultPermissions: [
      'dashboard.view',
      'leads.view', 'leads.create', 'leads.edit',
      'deals.view', 'deals.create', 'deals.edit',
      'contacts.view', 'contacts.create', 'contacts.edit',
      'users.view',
      'funcionarios.view', 'funcionarios.create', 'funcionarios.edit',
      'eventos.view', 'eventos.create', 'eventos.edit',
      'accesos.view', 'accesos.create', 'accesos.edit',
      'reports.view', 'reports.export',
      'callcenter.view', 'callcenter.create', 'callcenter.edit',
      'puertas.view'
    ],
    allowedRoutes: [
      'dashboard', 'leads', 'deals', 'contacts', 'usuarios',
      'funcionarios', 'eventos', 'accesos', 'reports', 'call-center'
    ],
    restrictions: {
      canEditOwnData: true,
      canViewAllData: true,
      canDeleteData: false,
    }
  },
  user: {
    name: 'User',
    description: 'Agente con acceso a gestión de leads y contactos',
    defaultPermissions: [
      'dashboard.view',
      'leads.view', 'leads.create', 'leads.edit',
      'deals.view', 'deals.create', 'deals.edit',
    ],
    allowedRoutes: ['dashboard', 'leads', 'deals'],
    restrictions: {
      canEditOwnData: true,
      canViewAllData: false,
      canDeleteData: false,
    }
  },
  viewer: {
    name: 'Visualizador',
    description: 'Solo acceso de lectura a la mayoría de datos',
    defaultPermissions: [
      'dashboard.view',
      'leads.view',
      'deals.view',
      'contacts.view',
      'funcionarios.view',
      'eventos.view',
      'accesos.view',
      'reports.view'
    ],
    allowedRoutes: ['dashboard', 'leads', 'deals', 'contacts', 'funcionarios', 'eventos', 'accesos', 'reports'],
    restrictions: {
      canEditOwnData: true,
      canViewAllData: false,
      canDeleteData: false,
    }
  },
  guest: {
    name: 'Invitado',
    description: 'Acceso muy limitado',
    defaultPermissions: [
      'dashboard.view'
    ],
    allowedRoutes: ['dashboard'],
    restrictions: {
      canEditOwnData: false,
      canViewAllData: false,
      canDeleteData: false,
    }
  }
};

// Configuración de rutas del sistema
export const ROUTE_CONFIG: RouteConfig[] = [
  {
    path: 'dashboard',
    component: 'Dashboard',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['dashboard.view'],
    title: 'Dashboard Leads',
    icon: 'home',
    showInSidebar: true
  },
  {
    path: 'dashboard-deals',
    component: 'DashboardDeals',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['dashboard.view'],
    title: 'Dashboard Deals',
    icon: 'home',
    showInSidebar: true
  },
  {
    path: 'leads',
    component: 'Leads',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['leads.view'],
    title: 'Leads',
    icon: 'users',
    showInSidebar: true
  },
  {
    path: 'leads/detail/:id',
    component: 'LeadDetail',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['leads.view'],
    title: 'Detalle Lead',
    showInSidebar: false
  },
  {
    path: 'deals',
    component: 'Deals',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['deals.view'],
    title: 'Deals',
    icon: 'handshake',
    showInSidebar: true
  },
  {
    path: 'deals/detail/:id',
    component: 'DealDetail',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['deals.view'],
    title: 'Detalle Deal',
    showInSidebar: false
  },
  {
    path: 'contacts',
    component: 'Contacts',
    allowedRoles: ['superadmin', 'admin', 'user'],
    requiredPermissions: ['contacts.view'],
    title: 'Contactos',
    icon: 'address-book',
    showInSidebar: true
  },

  {
    path: 'imports',
    component: 'Imports',
    allowedRoles: ['superadmin', 'admin'],
    requiredPermissions: ['imports.view'],
    title: 'Importar',
    icon: 'chart-bar',
    showInSidebar: true
  },

  {
    path: 'settings',
    component: 'Configuracion',
    allowedRoles: ['superadmin', 'admin'],
    requiredPermissions: ['configuracion.view'],
    title: 'Configuración',
    icon: 'cog',
    showInSidebar: true
  },
  {
    path: 'debug',
    component: 'Debug',
    allowedRoles: ['superadmin'],
    requiredPermissions: [],
    title: 'Debug',
    icon: 'bug',
    showInSidebar: true
  }
];

// Función para obtener rutas permitidas para un rol específico
export const getAllowedRoutes = (role: UserRole): RouteConfig[] => {
  
  if (ROLE_CONFIG[role]?.allowedRoutes.includes('*')) {
    return ROUTE_CONFIG;
  }
  
  const allowedPaths = ROLE_CONFIG[role]?.allowedRoutes || [];
  
  const filteredRoutes = ROUTE_CONFIG.filter(route => 
    allowedPaths.includes(route.path) || 
    allowedPaths.some(path => route.path.startsWith(path))
  );

  return filteredRoutes;
};

// Función para obtener rutas visibles en el sidebar para un rol
export const getSidebarRoutes = (role: UserRole): RouteConfig[] => {
  return getAllowedRoutes(role).filter(route => route.showInSidebar);
};

// Función para verificar si un rol tiene acceso a una ruta específica
export const canAccessRoute = (role: UserRole, routePath: string): boolean => {
  const route = ROUTE_CONFIG.find(r => r.path === routePath || routePath.startsWith(r.path));
  if (!route) return false;
  
  return route.allowedRoles.includes(role);
};

// Función para obtener permisos por defecto de un rol
export const getDefaultPermissions = (role: UserRole): Permission[] => {
  return ROLE_CONFIG[role]?.defaultPermissions || [];
};

// Función para verificar si un rol puede realizar una acción específica
export const canPerformAction = (
  role: UserRole, 
  action: Permission, 
  customPermissions?: Permission[]
): boolean => {
  const permissions = customPermissions || getDefaultPermissions(role);
  return permissions.includes(action);
};
